import React from "react";

const StudentDashboard = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-100 to-purple-100 py-10 px-4">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-8">
        <h2 className="text-3xl font-bold text-purple-700 mb-4 text-center">
          🎓 Student Dashboard
        </h2>
        <p className="text-gray-600 text-center mb-8">
          Welcome, Student! Track your classes and progress here.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 text-center">
          <div className="bg-purple-200 p-6 rounded-xl shadow hover:shadow-md transition">
            <h3 className="text-xl font-semibold text-purple-800">Enrolled Courses</h3>
            <p className="text-2xl font-bold mt-2">3</p>
          </div>
          <div className="bg-yellow-200 p-6 rounded-xl shadow hover:shadow-md transition">
            <h3 className="text-xl font-semibold text-yellow-800">Upcoming Classes</h3>
            <p className="text-2xl font-bold mt-2">2</p>
          </div>
          <div className="bg-green-200 p-6 rounded-xl shadow hover:shadow-md transition">
            <h3 className="text-xl font-semibold text-green-800">Performance</h3>
            <p className="text-2xl mt-2">⭐⭐⭐⭐</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentDashboard;
